module.exports = __webpack_public_path__ + "img/banner_readycall.bbf85d10.png";